
import { useEffect, useState } from "react";
import Grid from "../components/general/Grid";
import SlideMenu from "../components/general/SlideMenu";

export default function SpeciesPage(props) {
  const { speciesConfig, setColorBg, setLogoHeader, setShowSpecies } = props;

  useEffect(() => {
    setColorBg(speciesConfig.color);
    setLogoHeader(speciesConfig.header);
    setShowSpecies(false);
  }, [speciesConfig, setColorBg, setLogoHeader, setShowSpecies]);

  const [open, setOpen] = useState(false);
  const [contentSlideMenu, setContentSlideMenu] = useState();

  const openMenu = () => {
    setOpen(true);
  };

  return (
    <>
      <SlideMenu open={open} setOpen={setOpen} content={contentSlideMenu} />
      <div className="mb-8 animate-fade-up text-center">
        <span
          className="text-[0.7rem] font-semibold uppercase tracking-[0.25em]"
          style={{ color: speciesConfig.colorText ? '#21402c' : speciesConfig.accent }}
        >
          {speciesConfig.platform}
        </span>
        <h1 className="font-display text-3xl font-semibold italic text-ink sm:text-4xl">
          {speciesConfig.text}
        </h1>
      </div>
      <Grid
        openMenu={openMenu}
        setContentSlideMenu={setContentSlideMenu}
        ConfigVar={speciesConfig}
      />
    </>
  );
}
